import { DateTime } from "luxon";
import React from "react";
import { CompactDatePicker } from "sonobello.utilities.react.mui";

import { IDateSelectorProps } from "./ScheduleSlotSelector";

/** A date selector to be used when in desktop mode. */
const MobileDateSelector: React.FC<IDateSelectorProps> = ({ minDate, maxDate, value, onChange, shouldDisableDate }) => {
  const handleChange = (date?: DateTime) => {
    if (!date) return;
    onChange(date.plus(0));
  };
  return (
    <CompactDatePicker
      value={value || undefined}
      onChange={handleChange}
      pastDateMax={minDate.toISODate() ?? undefined}
      futureDateMax={maxDate.toISODate() ?? undefined}
      shouldDisableDate={shouldDisableDate}
    />
  );
};

export default MobileDateSelector;
